import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mantine/core";
import AppleSignin from "react-apple-signin-auth";
import { notifications } from "@mantine/notifications";

import { useAppleSignIn } from "../../api/auth";
import { AuthContext } from "../../services/context";
import { AppleIcon } from "../common/AppleIcon";

/**
 * A button component with Apple styling that includes the Google icon.
 *
 * @param {import("@mantine/core").ButtonProps} props - The props to spread onto the Button component
 * @returns {React.ReactElement} A Button component with Apple icon and styling
 */
export function AppleButton(props) {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const { mutate } = useAppleSignIn();

  const handleAppleSignIn = async (data) => {
    mutate(data, {
      onSuccess: (data) => {
        localStorage.setItem("token", data.token);
        setUser(data.user);
        navigate("/app");
      },
      // The error notification is shown by useApiMutation, using the message
      // from the API (no account / try again).
      onError: (error) => {
        console.error("Apple Sign In Error:", error);
        navigate("/");
      },
    });
  };

  return (
    <AppleSignin
      authOptions={{
        clientId: "rs.roundcube.congrs.service",
        scope: "email name",
        redirectURI: window.location.origin + "/callback",
        state: "",
        nonce: "nonce",
        usePopup: true,
      }}
      onSuccess={handleAppleSignIn}
      onError={(error) => {
        notifications.show({
          title: "Apple login failed",
          message: "Please try again.",
          color: "red",
        });
        navigate("/");
      }}
      render={({ onClick }) => (
        <Button
          h={40}
          leftSection={<AppleIcon />}
          variant="filled"
          {...props}
          color="black"
          onClick={onClick}
        />
      )}
    />
  );
}
